module.exports = __webpack_public_path__ + "static/media/elegant-2.72d487a3.png";